// Core
import React from 'react';
import { shallowEqual } from 'react-redux';
// Components
import { LineChart } from '../common/LineChart';
// Hooks:
import { useDatesChartData } from '../../hooks/useDatesChartData';
// Other
import { useTypedSelector } from '../../redux';

export const GuidesPerSessionTouch: React.FC = () => {
  const {
    data: { guidesPerSessionTouch },
    mode,
    startDate,
    endDate,
  } = useTypedSelector(({ total }) => total, shallowEqual);
  const {
    labelsNames, chartData,
  } = useDatesChartData(mode, guidesPerSessionTouch, startDate, endDate);

  return (
    <>
      {chartData.length > 0 && (
      <LineChart
        theme="blue"
        title="Touchscreen Guides per Session"
        subtitle="Amount open guides per session. One session can be converted to one user."
        label="Guides"
        labelsNames={labelsNames}
        data={chartData}
      />
      )}
    </>
  );
};
